let url = () =>{
    let url
    if(process.env.NODE_ENV === 'development') {
        url = `http://139.162.234.164:81/api`
    } else {
        url = ''
    }
    return url
}

export default url;